import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

import * as styles from './index.vanilla.css'

interface Props {
  selected: boolean
}

const RadioInput = (props: Props) => {
  const { selected } = props

  return (
    <div className={styles.checkbox[selected ? 'selected' : 'default']}>
      {selected && (
        <span className={styles.iconWrapper}>
          <Icon.Medium icon="check" color="grey000White" />
        </span>
      )}
    </div>
  )
}

export default RadioInput
